import { render } from "./Descr.vue?vue&type=template&id=83fe7c1e&scoped=true"
import script from "./Descr.vue?vue&type=script&lang=js"
export * from "./Descr.vue?vue&type=script&lang=js"

import "./Descr.vue?vue&type=style&index=0&id=83fe7c1e&lang=scss&scoped=true"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83fe7c1e"]])

export default __exports__